module.exports = __webpack_public_path__ + "img/bg_header.99c1c183.png";